<template>
  <div class="flex w-full relative">
    <div class="flex-1 absolute md:static h-full">
      <img
        alt="thanks for shopping"
        src="/images/Thanks for shopping (1).png"
        class="max-w-[100vw] md:max-w-[50vw] w-screen md:w-full h-full object-cover object-center absolute"
      />
    </div>
    <div
      class="flex-1 flex items-center justify-center bg-white md:bg-transparent rounded-2xl p-7 relative mx-5 my-6 md:min-h-[80vh]"
    >
      <div
        v-if="orderData && !pendingOrderData"
        class="max-w-[360px] space-y-6"
      >
        <div>
          <div class="text-[32px] font-bold text-center mb-2">
            {{ $t('orderConfirmation.thanksForChoosingCaseClub') }}
          </div>
          <div class="text-center font-bold">
            {{ $t('orderConfirmation.order') }}:
            {{ orderData?.data.order_number }}
          </div>
        </div>
        <div v-if="pickupOrder" class="space-y-2">
          <div class="text-center">
            {{ $t('orderConfirmation.pickupDetail') }}
          </div>
          <!-- <div class="mb-8 text-center">
            {{ $t('orderConfirmation.youCanPickUpAt') }}
          </div>
          <div class="bg-[#F2F2F3] p-4 rounded-2xl">
            <div class="font-[500]">
              {{ orderData.data.pickup_location.name }}
            </div>
            <div class="text-sm">
              {{ orderData.data.pickup_location.address }}
            </div>
          </div>
          <div class="bg-[#F2F2F3] p-4 rounded-2xl">
            <div class="font-[500]">{{ pickupDate }}</div>
            <div class="text-sm">
              {{ $t('orderConfirmation.availableTime') }} 10:00-18:00
            </div>
          </div> -->
        </div>
        <div v-if="!pickupOrder">
          <div class="text-center">
            {{ $t('orderConfirmation.deliveryDetail') }}
          </div>
        </div>

        <div class="flex flex-col space-y-4">
          <img
            v-if="
              orderData?.data?.product_items?.length &&
              (!!orderData?.data.product_items[0]?.personalization_image ||
                !!orderData?.data.product_items[0]?.style?.thumbnail_url ||
                !!orderData?.data.product_items[0]?.product_variant_detail
                  ?.thumbnail_url)
            "
            alt="order confirm"
            :src="
              config.public.mediaUrl +
              (orderData?.data.product_items[0]?.personalization_image ||
                orderData?.data.product_items[0]?.style?.thumbnail_url ||
                orderData?.data.product_items[0]?.product_variant_detail
                  ?.thumbnail_url)
            "
            class="rounded-[8px] object-contain block max-h-[189px] mb-3"
          />
          <Button
            @click="
              () =>
                router.push(
                  localePath(`/account/my-orders/${orderData.data.id}`)
                )
            "
          >
            {{ $t('orderConfirmation.viewOrderConfirmation') }}
          </Button>
          <div>
            <NuxtLinkLocale
              to="/"
              class="items-center flex justify-center font-bold cursor-pointer"
            >
              {{ $t('orderConfirmation.backHome') }}
            </NuxtLinkLocale>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { map } from 'lodash-es'

definePageMeta({
  layout: 'order-confirmation'
})
const localePath = useLocalePath()

const pickupOrder = ref<boolean | null>(null)
// const pickupDate = ref('')

const config = useRuntimeConfig()
const router = useRouter()
const route = useRoute()

const orderId = computed(() => route.params.orderId)
const status = computed(() => route.query.status as string)
const purchase = computed(() => route.query.purchase as string)
const token = computed(() => route.query.token as string)

const { updateOrderDetail } = useOrderStoreV2()

useSeoMeta({
  title: 'Thanks for shopping at CaseClub!'
})

const { on } = useEventTracking()
const { transGtagPurchase } = useTransform()

const { data: orderData, pending: pendingOrderData } =
  await useQuery<GetOrderDetailResponse>(
    () => `/v2/storefront/order/${orderId.value}/detail`,
    {
      server: false,
      method: 'get',
      key: 'get-order-detail',
      onResponse: ({ response }) => {
        if (response.status !== 200) {
          // router.push(localePath('/'))

          const order = response._data.data
          updateOrderDetail(order)
        } else {
          if (response._data.data.payment_status !== 'paid') {
            // router.push(localePath('/checkout/' + orderId.value))
          } else {
            const order = response._data.data
            pickupOrder.value = order.delivery_type === 'pickup'
            if (purchase.value === 'success') {
              console.log('Tracking Event Fired')
            }

            const purchaseData = transGtagPurchase(order)
            on('purchase', purchaseData)
          }
        }
      }
    }
  )

onMounted(() => {
  if (status.value === 'fail' && !!orderId.value) {
    router.replace({
      path: localePath(`/checkout/${orderId.value}`),
      query: {
        token: token.value,
        redirect: 'payment',
        status: status.value
      }
    })
  }
})
</script>
